import z from 'zod';
export const UrlSchema = z.string().regex(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/, "Not a valid url format, must follow http(s)://{domain}.{end}");

// URL validation with TLD check
export const urlWithTLDErrorMessage = 'Invalid URL format. Must include a valid domain with extension (e.g., https://your-site.com)';
export const urlBasicErrorMessage = 'Invalid URL entered, must follow format https://your-site.com';
/**
 * Validates URL and returns error message or null
 * Used for both schema validation and onBlur validation
 */
export const validateUrlWithTLD = (value: string, required: boolean = true): string | null => {
  if (!value || value.trim().length === 0) {
    return required ? 'This field is required' : null;
  }
  try {
    const url = new URL(value);
    const hasTLD = /\.[a-zA-Z]{2,}$/.test(url.hostname);
    if (!hasTLD) {
      return urlWithTLDErrorMessage;
    }
    return null;
  } catch {
    return urlBasicErrorMessage;
  }
};

/**
 * Validates a URL has a proper TLD (top-level domain)
 * Returns true if valid, false otherwise
 */
export const hasValidTLD = (value: string): boolean => {
  try {
    const url = new URL(value);
    // Check if hostname has a TLD (ends with a dot followed by 2+ letters)
    return /\.[a-zA-Z]{2,}$/.test(url.hostname);
  } catch {
    return false;
  }
};

/**
 * Zod schema for URL with TLD validation
 * Use this for consistent URL validation across schemas
 */
export const UrlWithTLDSchema = z.string()
  .url(urlBasicErrorMessage)
  .refine(hasValidTLD, urlWithTLDErrorMessage);

/**
 * Required URL with TLD validation (includes min check)
 */
export const RequiredUrlWithTLDSchema = z.string()
  .min(1, 'This field is required')
  .url(urlBasicErrorMessage)
  .refine(hasValidTLD, urlWithTLDErrorMessage);